import { FormFieldsGeneratorService } from './../../customer-form/form-helpers/form-fields-generator.service';
import { Component, Input } from '@angular/core';
import SlotModel from '../../models/slot.model';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'slot-tv-input',
  templateUrl: './slot-tv-input.component.html'
})
export default class SlotTvInputComponent {
  @Input() slot: SlotModel;

  public slotOfferForm: FormGroup;

  constructor(private formsGenerator: FormFieldsGeneratorService) {}

  protected onEditMode(event: Event): void {
    this.formsGenerator.setFirstStepActiveForm();
    this.slotOfferForm = this.formsGenerator.activeForm;
    this.slot.manageTv.onEditMode(event);
  }
}
